import _ from "lodash";

const imageModalities = [
  {category: 'SEM', label:'All SEM', tags:['SEM']},
  {category: 'SEM', label:'ATUM-SEM - Automatic Tape-collecting Ultra-Microtome SEM', tags:['ATUM-SEM']},
  {category: 'SEM', label:'SBEM - Serial block-face SEM', tags:['SBEM']},
  {category: 'SEM', label:'FIB-SEM - Focused Ion Beam SEM', tags:['FIB-SEM']},
  {category: 'SEM', label:'ssSEM - Serial Section SEM', tags:['ssSEM']},
  {category: 'TEM', label:'All TEM', tags:["TEM"]},
  {category: 'TEM', label:'ssTEM - Serial Section Transmission Electron Microscope', tags:['ssTEM']},
  {category: 'TEM', label:'STEM - Scanning Transmission Electron Microscope', tags:['sTEM']},
  {category: 'TEM', label:'AT-TEM -  Array Tomography Transmission Electron Microscope', tags:['AT-TEM']},
  {category: 'X-RAY', label:'All X-Ray', tags:['X-ray']},
  {category: 'X-RAY', label:'XRM - X-Ray Microtomography', tags:['XRM']},
  {category: 'X-RAY', label:'XNH - X‐Ray Nanoholotomography', tags:['XNH']},
  {category: 'Other', label:'All Other', tags:['fMRI', 'DTI', 'CLARITY', 'MRI', 'LM', 'FM']},
  {category: 'Other', label:'fMRI - Functional MRI', tags:['fMRI']},
  {category: 'Other', label:'DTI - Diffusion Tensor Imaging', tags:['DTI']},
  {category: 'Other', label:'CLARITY', tags:['CLARITY']},
  {category: 'Other', label:'MRI', tags:['MRI']},
  {category: 'Other', label:'Light Microscopy', tags:['LM']},
  {category: 'Other', label:'Fluorescence Microscopy', tags:['FM']}
];

const tagIsImageModality = (tag) => {
  return _.flatten(imageModalities.map(im => im.tags)).includes(tag);
}

export default imageModalities;
